import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { CircularProgress } from '@mui/material';
import { API_BASE_URL } from '../../config/constants';
import EventTimeline, { TimelineEvent } from '../common/EventTimeline';

/**
 * تایم‌لاین کامل سفارش برای ادمین — رویدادها را از endpoint زیر می‌خواند و با
 * رندر مشترک EventTimeline نمایش می‌دهد:  GET /admin/orders/:orderId/timeline
 */

export type { TimelineEvent };

interface OrderTimelineProps {
  orderId: string;
}

const OrderTimeline: React.FC<OrderTimelineProps> = ({ orderId }) => {
  const [events, setEvents] = useState<TimelineEvent[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setError(null);
    try {
      const token = localStorage.getItem('accessToken');
      const res = await axios.get(`${API_BASE_URL}/admin/orders/${orderId}/timeline`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data.status === 'success') {
        setEvents(res.data.data.events || []);
      } else {
        setError('خطا در دریافت تایم‌لاین');
      }
    } catch (e: any) {
      setError(e?.response?.data?.message || 'خطا در دریافت تایم‌لاین سفارش');
    }
  }, [orderId]);

  useEffect(() => {
    load();
  }, [load]);

  if (!events && !error) {
    return (
      <div style={{ padding: 24, textAlign: 'center' }}>
        <CircularProgress size={24} />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: 16, background: '#ffebee', borderRadius: 6, fontSize: 13, color: '#c62828' }}>
        {error}
        <button
          onClick={load}
          style={{ marginRight: 8, border: 'none', background: 'transparent', color: '#c62828', cursor: 'pointer', textDecoration: 'underline', fontSize: 12 }}
        >
          تلاش مجدد
        </button>
      </div>
    );
  }

  return <EventTimeline events={events || []} onRefresh={load} />;
};

export default OrderTimeline;
